import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'


interface DefaultModalProps {
  isOpen: boolean
  dialogPanelClass?: string
  handleCloseModal: () => void
  children: JSX.Element
}
export default function DefaultModal({ isOpen, dialogPanelClass, handleCloseModal, children }: DefaultModalProps) {
  return (
    <>
      <Transition
        appear
        show={isOpen}
        as={Fragment}
        data-testid="test-AssumirNotification"
      >
        <Dialog
          as="div"
          className="relative z-40"
          onClose={handleCloseModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={`${dialogPanelClass} bg-white rounded-2xl `}>
                  {children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
